import {createAsyncThunk, createSlice, PayloadAction} from '@reduxjs/toolkit'
import {http} from 'hiya-common/src/utils/axios'
import {HomepageMock} from './mock'

export const getHomepageData = createAsyncThunk(
  'getHomepageData',
  async (_, store: any) => {
    // return HomepageMock
    const resp = await http.post(
      '/live/activity/puzzle24_card',
      {},
      {
        store: window.store,
      }
    )
    return resp.data?.data
  }
)

const initialState: {
  homepage?: {
    err_msg?: string
    activity_status?: number
    flip_rewards?: {
      reward_level: number
      rewards: {
        id: number
        name: string
        view_icon: string
        toast_name: string
        reward_type: number
        tag: string
        privilege_id: number | null
        origin_id: number | null
        quantity: number
        reward_value: number
        has_show_effect: boolean
      }[]
    }[]
    flip_chances?: number
    collect_rewards?: {
      id: number
      name: string
      view_icon: string
      toast_name: string
      reward_type: number
    }[]
    collect_top_rewards?: {
      id: number
      name: string
      view_icon: string
      toast_name: string
      reward_type: number
    }[]
    collect_top_limit?: number
    collect_top_users?: {
      id: number
      name: string
      zy_id: string
      avatar: string
      gender: number
    }[]
    collect_task_list?: {
      id: number
      desc: string
      target: number
      status: number
      progress: number
      type: number
    }[]
    collect_status?: number
    recharge_coins_per_flip?: number
    biggest_reward?: {
      id: number
      name: string
      view_icon: string
      toast_name: string
      reward_type: number
    }
    is_first_enter?: boolean
    init_free_chances?: number
    rank_rewards?: {
      idx: number
      ranks: number[]
      item_list: {
        img: string
        desc: string
        reward_id: number
        reward_type: number
        reward_value: number
        desc_name: string
        desc_icon: string
        has_show_effect: boolean
        reward_quantity: number
      }[]
      name: string
      role: number
      reward_min_score: number
    }[]
    rank_reward_top_n?: number
    is_allowed?: boolean
  }
} = {
  homepage: {},
}

export const Puzzle24Slice = createSlice({
  name: 'Puzzle24',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getHomepageData.fulfilled, (state, action) => {
      Object.assign(state.homepage, action.payload)
    })
  },
})

export default Puzzle24Slice.reducer
export const Puzzle24Actions = Puzzle24Slice.actions
